import { useState } from "react";
import { toast } from "sonner";

const WHATSAPP = "972505887774";
const BUDGETS = ["Under $10k", "$10k – $25k", "$25k – $50k", "$50k+"];

export default function Contact() {
  const [form, setForm] = useState({ name: "", company: "", need: "", budget: "" });

  const set = (key) => (e) => setForm({ ...form, [key]: e.target.value });

  const submit = (e) => {
    e.preventDefault();
    if (!form.name.trim() || !form.need.trim()) {
      toast.error("Please add your name and what you need.");
      return;
    }
    const msg = `Hi Cactus! I'm ${form.name}${form.company ? ` from ${form.company}` : ""}. I need: ${form.need}.${form.budget ? ` Budget: ${form.budget}.` : ""}`;
    window.open(
      `https://wa.me/${WHATSAPP}?text=${encodeURIComponent(msg)}`,
      "_blank",
      "noopener,noreferrer"
    );
    toast.success("Opening WhatsApp — your message is ready to send.");
    setForm({ name: "", company: "", need: "", budget: "" });
  };

  return (
    <main className="section page-top contact-page" data-testid="contact-page">
      <p className="eyebrow">Contact</p>
      <h1 className="page-headline" data-testid="contact-headline">
        Start a project
      </h1>
      <a
        href="tel:+972505887774"
        className="contact-email"
        data-testid="contact-phone-link"
      >
        050-588-7774
      </a>
      <div className="contact-socials">
        <a
          href="https://www.instagram.com/cactus2brand/"
          target="_blank"
          rel="noopener noreferrer"
          className="contact-instagram"
          data-testid="contact-instagram-link"
        >
          @cactus2brand
        </a>
        <a
          href="https://www.facebook.com/cactus.graphics/"
          target="_blank"
          rel="noopener noreferrer"
          className="contact-instagram"
          data-testid="contact-facebook-link"
        >
          fb / cactus.graphics
        </a>
      </div>
      <p className="contact-address" data-testid="contact-address">
        Alkuds St 357, Baqa al-Gharbiyye &nbsp;·&nbsp; ★ 5.0 on Google
      </p>

      <form className="contact-form" onSubmit={submit} data-testid="contact-form">
        <div className="form-row">
          <label>
            Name
            <input
              type="text"
              value={form.name}
              onChange={set("name")}
              placeholder="Your name"
              data-testid="contact-name-input"
            />
          </label>
          <label>
            Company
            <input
              type="text"
              value={form.company}
              onChange={set("company")}
              placeholder="Your company"
              data-testid="contact-company-input"
            />
          </label>
        </div>
        <label>
          What you need
          <textarea
            rows={4}
            value={form.need}
            onChange={set("need")}
            placeholder="Naming, identity, packaging…"
            data-testid="contact-need-input"
          />
        </label>
        <fieldset className="budget-group">
          <legend>Budget range</legend>
          <div className="budget-options">
            {BUDGETS.map((b) => (
              <button
                key={b}
                type="button"
                className={`budget-pill ${form.budget === b ? "selected" : ""}`}
                onClick={() => setForm({ ...form, budget: b })}
                data-testid={`budget-option-${b.replace(/[^a-z0-9]+/gi, "-").toLowerCase()}`}
              >
                {b}
              </button>
            ))}
          </div>
        </fieldset>
        <button type="submit" className="submit-btn" data-testid="contact-submit-button">
          Send via WhatsApp
        </button>
      </form>
    </main>
  );
}
